import { authHeader } from './authHeaders';

// A plain <a href> can't carry the Authorization header the backend now
// requires (routers/word_generation.py's /download endpoint), so this
// fetches the file as a blob with the header attached and triggers the
// browser's own "Save As" via a throwaway object URL instead.
export async function downloadAuthenticatedFile(url, filename) {
  const response = await fetch(url, { headers: { ...authHeader() } });
  if (!response.ok) throw new Error('Download failed');
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
}
